<template>
  <div class="container">
    <div class="searchInput">
      <input type="text" v-model="val" placeholder="请输入关键词搜索" @keyup.enter="submitSearch" @blur="search" />
      <img src="../../../static/image/commonIcon/serch.png" alt  @click="submitSearch" />
    </div>
  </div>
</template>

<script>
export default {
  name: "searchInput",
  data() {
    return {
      val:''
    };
  },
  created() {},

  methods: {
    search(){
      this.$parent.changeVal(this.val);
    },
    submitSearch(){
      this.$parent.changeVal(this.val);
      this.$parent.submitSearch();
    }
  },
};
</script>


<style scoped>
.container {
  width: 100%;
  text-align: center;
}
.searchInput {
  display: flex;
  align-items: center;
  justify-content: center;
}
.searchInput input {
  width: 454px;
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  opacity: 1;
  padding: 0 15px;
}
.searchInput img {
  width: 19px;
  height: 19px;
  position: relative;
  left: -40px;
}
</style>



// WEBPACK FOOTER //
// src/components/searchInput/searchInput.vue